import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import OAuthConsent from "@/pages/OAuthConsent";
export const Route = createFileRoute("/.lovable/oauth/consent")({ head: ({match}) => pageHead(match.pathname), component: () => (<OAuthConsent />) });
